import { LOGO_PIN, FOOTER_VIDEO, PARKING_BG } from "@/content";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden border-t border-white/10 bg-ink">
      <video
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
        poster={PARKING_BG}
        className="absolute inset-0 w-full h-full object-cover opacity-70"
      >
        <source src={FOOTER_VIDEO} type="video/mp4" />
      </video>
      <div className="absolute inset-0 bg-gradient-to-b from-ink/80 via-ink/55 to-ink/85" />

      <div className="relative z-10 mx-auto max-w-7xl px-6 py-20">
        <div className="max-w-2xl">
          <div className="font-mono text-xs tracking-[0.28em] uppercase text-brand-green">Invest in the future of parking</div>
          <h2 className="mt-4 font-heading font-extrabold text-3xl sm:text-4xl tracking-tight">
            Higher revenue. Better cities. <span className="text-gradient">Real impact.</span>
          </h2>
        </div>

        <div className="mt-16 flex flex-col md:flex-row md:items-center justify-between gap-8">
          <div className="flex items-center gap-3">
            <img src={LOGO_PIN} alt="GeoDyn" className="h-24 w-24 object-contain drop-shadow-[0_0_16px_rgba(0,229,255,0.55)]" />
            <div>
              <div className="font-heading font-extrabold text-lg tracking-tight">
                GEODYN <span className="text-brand-green">PARKING</span>
              </div>
              <div className="font-mono text-xs tracking-[0.2em] uppercase text-white/50">The Intelligence Layer for Parking</div>
            </div>
          </div>

          <div className="font-mono text-xs tracking-wider text-white/60 space-y-1 md:text-right">
            <div>More revenue. Less traffic. Better cities. Happier people.</div>
            <div>geodynparking.com</div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-white/40">
          <span>© {new Date().getFullYear()} GeoDyn Parking. All rights reserved.</span>
          <a href="/admin" data-testid="footer-admin-link" className="hover:text-white/70 transition-colors">Admin Login</a>
        </div>
      </div>
    </footer>
  );
};
